import React from 'react';
import { useTour } from './TourContext';
import '../ui/guide.css';

/**
 * The ? beside a page title (decision 86: PageHeader renders it straight after the H1 when the page
 * passes `help`; a few pages place it themselves).
 * <HelpButton tourId="crm" />
 *
 * Tapping it opens the page's guide from the first step, even if the person has already finished
 * or dismissed it (Block M: the shared spotlight guide, ui/Guide.jsx). Tokens only (guide.css).
 */
export default function HelpButton({ tourId }) {
  const { openGuide } = useTour();

  return (
    <button
      type="button"
      onClick={() => openGuide(tourId, { force: true })}
      title="Show the page guide"
      aria-label="Help, open page guide"
      className="btn-circle ui-help"
    >
      ?
    </button>
  );
}
